import { BaseEntity, type ValidationResult } from '@memberjunction/core';
import { RegisterClass } from '@memberjunction/global';
import { FeedbackPlatformPresentationEntity } from 'mj_generatedentities';
import { OEP_ENTITY } from '../contracts/entities.js';
import { BeginRules } from './shared.js';

/**
 * Final review C1. Presentations is shared by v1 (archive, SeasonID NULL) and OEP. RLS confines every v1 role to
 * archive rows, but MJ checks an Update against the row as stored, so without this rule a v1 presenter could save
 * their archive row WITH an OEP SeasonID/SectionID/SessionID and inject it into a live season. Non-staff savers may
 * never change those three columns (DecideForeignKeysUnchanged, fresh DB read — never the client OldValue).
 */
@RegisterClass(BaseEntity, OEP_ENTITY.Presentations)
export class OEPPresentationEntity extends FeedbackPlatformPresentationEntity {
    override get DefaultSkipAsyncValidation(): boolean { return false; }
    override async ValidateAsync(): Promise<ValidationResult> {
        const result = await super.ValidateAsync();
        await BeginRules(this, this.ActiveUser, result, 'Presentations', this.ID, {
            SeasonID: this.SeasonID, SectionID: this.SectionID, SessionID: this.SessionID,
        });
        return result;
    }
}
